function initMap() {
  const element = $("#anuncio-mapa");
  const icon = element.data("icon");
  const lat = element.data("lat");
  const lng = element.data("lng");
  const local = {
    id: element.data("id"),
    url: element.data("url"),
    lat: Number(element.data("lat")),
    lng: Number(element.data("lng")),
    img: element.data("img"),
    titulo: element.data("titulo"),
    cidade: element.data("cidade"),
  };
  let caixa;

  const mapOptions = {
    zoom: 15,
    center: new google.maps.LatLng(lat, lng),
  };

  const mapElement = element.get(0);
  const map = new google.maps.Map(mapElement, mapOptions);
  caixa = new google.maps.InfoWindow();
  google.maps.event.addListener(map, "click", function () {
    caixa.close();
  });
  const marker = new google.maps.Marker({
    position: new google.maps.LatLng(lat, lng),
    icon: icon,
    map: map,
  });
  marker.addListener("click", function () {
    caixa.setContent(`
      <a class="map-popup map-popup-det">
        <figure>
          <img src="${local.img}" alt="${local.titulo}">
        </figure>
        <div class="map-popup-infos">
          <div class="map-popup-inner">
            <div class="map-popup-titulo">${local.titulo}</div>
            <div class="map-popup-cidade">${local.cidade}</div>
          </div>
        </div>
      </a>`);
    caixa.open(map, marker);
  });
}
